import React from 'react';

export const Work = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3333 2.4987C11.0321 2.4987 9.16666 4.36418 9.16666 6.66536C9.16666 7.37052 9.34119 8.03251 9.64869 8.61288C9.82002 8.93624 9.76034 9.33353 9.50158 9.59229L2.84517 16.2487L3.74999 17.1535L10.4064 10.4971C10.6652 10.2384 11.0625 10.1787 11.3858 10.35C11.9662 10.6575 12.6282 10.832 13.3333 10.832C15.6345 10.832 17.5 8.96654 17.5 6.66536C17.5 6.38309 17.472 6.10774 17.4188 5.84177L15.1726 8.08795C14.8471 8.41339 14.3195 8.41339 13.9941 8.08795L11.9107 6.00462C11.5853 5.67918 11.5853 5.15155 11.9107 4.82611L14.1569 2.57992C13.891 2.52666 13.6156 2.4987 13.3333 2.4987ZM7.5 6.66536C7.5 3.4437 10.1117 0.832031 13.3333 0.832031C14.3171 0.832031 15.2463 1.07623 16.0612 1.50801C16.2948 1.6318 16.4558 1.85912 16.4951 2.12059C16.5344 2.38206 16.4472 2.64665 16.2603 2.83362L13.6785 5.41536L14.5833 6.32019L17.1651 3.73844C17.352 3.55148 17.6166 3.46434 17.8781 3.50361C18.1396 3.54288 18.3669 3.70391 18.4907 3.93755C18.9224 4.75243 19.1667 5.68161 19.1667 6.66536C19.1667 9.88702 16.555 12.4987 13.3333 12.4987C12.5718 12.4987 11.843 12.3524 11.1746 12.086L4.33925 18.9213C4.01381 19.2467 3.48618 19.2467 3.16074 18.9213L1.07741 16.838C0.751969 16.5125 0.751969 15.9849 1.07741 15.6594L7.91273 8.82412C7.64634 8.15571 7.5 7.42689 7.5 6.66536Z"
                fill="#28B57A"
            />
        </svg>
    );
};
